export { FREE_TRIAL_COPY } from './lang/en-US';
export type { FreeTrialCopy } from './lang/en-US';

export {
  getAccountsApiBaseUrl,
  TRIAL_FEATURES,
  TRIAL_UPGRADE_REQUEST_ENDPOINTS,
} from './api/constants';
export type { TrialFeature } from './api/constants';

/** @deprecated Use TRIAL_FEATURES */
export { TRIAL_FEATURES as TRIAL_RESTRICTED_FEATURES } from './api/constants';
/** @deprecated Use TrialFeature */
export type { TrialFeature as TrialRestrictedFeature } from './api/constants';

export {
  isTrialSessionEndedError,
  TrialSessionEndedError,
  TRIAL_SESSION_ENDED_MESSAGE,
} from './api/errors';

export {
  postTrialUpgradeRequest,
  TrialUpgradeRequestError,
} from './api/request';
export type {
  TrialUpgradeRequestPayload,
  TrialUpgradeRequestResponse,
} from './api/request';

export { useTrialUpgradeRequestMutation } from './api/hooks/useTrialUpgradeRequestMutation';
export type { TrialUpgradeNotifyHandlers } from './api/hooks/useTrialUpgradeRequestMutation';

export {
  startTrialLockoutBackgroundPreload,
  usePreloadImage,
} from './hooks/usePreloadTrialLockoutBackground';

export {
  TrialLockoutProvider,
  useTrialLockout,
} from './providers/TrialLockoutProvider';

export type {
  TrialLockoutContextValue,
  TrialLockoutProviderProps,
} from './providers/TrialLockoutProvider';

export { TrialLockoutModal } from './components/trial-lockout-modal';
export type { TrialLockoutModalProps } from './components/trial-lockout-modal';
